//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    close: {
      type: Boolean,
      default: true
    }
  }
};